import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import type { FC } from "react";
import { z } from "zod";

const RootComponent: FC = () => {
  return <Outlet />;
};

// biome-ignore assist/source/useSortedKeys: ordering required for type inference, waiting a TanStack Biome plugin
export const Route = createFileRoute("/_public/_auth")({
  validateSearch: z.object({
    redirect_uri: z.optional(z.string()).catch(""),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      // TODO: Change to the following line when all routes are migrated to React
      // throw redirect({ to: search.redirect_uri || fallback, replace: true });

      throw redirect({
        replace: true,
        search: { redirect_uri: search.redirect_uri },
        to: "/redirect/rails/home",
      });
    }
  },
  component: RootComponent,
});
